import React from 'react';
import PropTypes from 'prop-types';
import {Formik} from 'formik';

import ValidationSchema from './EmailFormValidationSchema';

import FormComponent from './FormComponent';

import {DisplayFormikState} from 'components/DisplayFormikState';

const EmailForm = ({ record, handleSubmit, handleReset }) => {
    const renderForm = (props) => (
        <React.Fragment>
            <FormComponent {...props} />
            {false && <DisplayFormikState {...props} />}
        </React.Fragment>
    );

    return (
        <Formik
            initialValues={record}
            validationSchema={ValidationSchema}
            onSubmit={handleSubmit}
        >
            {renderForm}
        </Formik>
    );
};

EmailForm.propTypes = {
    record: PropTypes.object,
    handleSubmit: PropTypes.func,
    handleReset: PropTypes.func,
};

export default EmailForm;
